import { useContext } from "react";

import Listing from "./Listing";
import Project from "./Project";
import Land_Sale from "./Land_Sale";
import Mortgage from "./Mortgage";

import { AppContext } from "/src/components/context/App";

function Component(props) {

  const context = useContext(AppContext);

  switch (context?.post_type) {
    case "project":
      return <Project {...props} />;
    case "listing":
      return <Listing {...props} />;
    case "land_sale":
      return <Land_Sale {...props} />;
    case "mortgage":
      return <Mortgage {...props} />;
    default:
      return null;
  }

}

export default Component;
